import { useEffect, useState } from "react";
import { BakeItem } from "../model/bakeItem";

export type BakeData = {
  isLoading: boolean;
  bakeData?: BakeItem;
};

const serverURL =
  process.env.REACT_APP_USE_REAL_BACKEND === "true"
    ? process.env.REACT_APP_REAL_BACKEND
    : process.env.REACT_APP_LOCAL_BACKEND;

const useBakeService = () => {
  const [result, setResult] = useState<BakeData>({
    isLoading: true,
  });

  useEffect(() => {
    fetch(`${serverURL}/upcoming`)
      .then((response) => response.json())
      .then((response) => {
        setResult({ isLoading: false, bakeData: response });
      })
      .catch(() => setResult({ isLoading: false, bakeData: undefined }));
  }, []);

  return result;
};

export default useBakeService;
